<h3 mat-dialog-title>Återköp banköverföring</h3>

<div mat-dialog-content>
  <p>Maxbelopp för återbetalning: {{data.maxRefund}} kr</p>

  @if (bankTransferForm) {
    <form [formGroup]="bankTransferForm">
      <!-- Refund sum -->
      <div class="input">
        <mat-form-field>
          <mat-label>Summa att återbetala</mat-label>
          <input matInput type="number" formControlName="refundAmount">
          <mat-error>Ogiltigt belopp</mat-error>
        </mat-form-field>
      </div>
      <!-- Refund comment -->
      <div class="input">
        <mat-form-field>
          <mat-label>Anledning till återköp</mat-label>
          <input matInput formControlName="refundComment">
          <mat-error>Kommentar krävs</mat-error>
        </mat-form-field>
      </div>
    </form>
  }

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close>Avbryt</button>
    <button mat-button (click)="refund()" [ngClass]="{'button': true, 'loading': loading}"
      [disabled]="!bankTransferForm?.valid || loading">Genomför återbetalning
      @if (loading) {
        <mat-spinner diameter="25" color="accent"></mat-spinner>
      }
    </button>
  </div>
</div>